import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import MinigraphCard from "./minigraphCard";
import AnalyticsLoading from "../analyticsLoading";
import AnalyticsError from "../analyticsError";

interface OrganizationCardProps {
  devMode: boolean;
  data: any;
  fetchOrganizationData: any;
  teamId: string;
  requestStatus: string;
}

class OrganizationCard extends React.Component<OrganizationCardProps, any> {
  componentDidMount() {
    if (this.props.requestStatus === "loading") {
      this.props.fetchOrganizationData();
    }
    if (this.props.data !== null && this.props.requestStatus !== "error") {
      $("#org-chart-container").html(this.props.data.html);
    }
  }

  render() {
    return (
      <div id="org-card">
        <MinigraphCard
          devMode={this.props.devMode}
          title={this.getTitle()}
          url={this.getUrl()}
          chartName="organization"
        >
          <div id="org-chart-container" className="org-chart-container" />
          {this.renderContent()}
        </MinigraphCard>
      </div>
    );
  }

  renderContent = () => {
    if (this.props.requestStatus === "error") {
      return (
        <AnalyticsError
          error={i18n.translate("analyticsv2.something_went_wrong")}
        />
      );
    }
    if (this.props.requestStatus === "loading") {
      return <AnalyticsLoading />;
    }
    return null;
  };

  getTitle = () => {
    return i18n.translate("analyticsv2.organization_card.title");
  };

  getUrl = () => {
    return `/analytics/organization_charts/teams/${this.props.teamId}`;
  };
}

export default OrganizationCard;
